/**
 * Body loader function
 * @param value
 */
window.setBodyLoader = (value) => {
    if (value) {
        $('#body__spinner').css('display', 'block');
    } else {
        $('#body__spinner').css('display', 'none');
    }
}
